<!--
 * @FileDescription: 刊登选择平台店铺弹窗
 * @Author: 苏子龙
 * @Date: 2021/12/16

<SelectStoreToPublish ref="selectStoreToPublish"></SelectStoreToPublish>

this.$refs.selectStoreToPublish.show(kkProductId)
 -->
<template>
    <!-- 刊登弹窗 -->
  <div>
    <el-dialog :title="$t('Components.SelectStoreToPublish.Tips1')" width="700px" :close-on-click-modal="false" :visible.sync="publishVisible" class="publish-dialog">
      <!-- <p class="publish-text">Currently, only publishing items to Shopify is supported</p> -->
      <el-form ref="publishForm" :inline="true" :model="publishForm" :rules="publishRules">
        <el-form-item :label="$t('Components.SelectStoreToPublish.Platform')" prop="platform">
          <el-select v-model="publishForm.platform" @change="platformChange">
            <el-option v-for="item in platformSelect" :key="item.platformCode" :label="item.platformName" :value="item.platformCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Components.SelectStoreToPublish.Store')" prop="storeId" style="padding-left: 30px;">
          <el-select v-model="publishForm.storeId" filterable >
            <el-option v-for="item in storeSelect" :key="item.storeId" :label="item.storeName" :value="item.storeId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="publishVisible = false">{{ $t('Components.SelectStoreToPublish.Cancel') }}</el-button>
        <el-button size="small" type="primary" @click="publish">{{ $t('Components.SelectStoreToPublish.Submit') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('Components.SelectStoreToPublish.Tips2')" :visible.sync="noShopVisible" width="630px" class="no-shop">
      <div class="f--c" style="margin-bottom:20px">
        <div>{{ $t('Components.SelectStoreToPublish.AllowStoreBinding') }}：</div>
        <img style="height:40px" src="@/assets/img/homePage/shopify.png" alt="">
        <img style="height:34px" src="@/assets/img/homePage/shoplazza.png" alt="">
        <img style="height:40px" src="@/assets/img/homePage/shopline.png" alt="">
        <img style="height:40px;margin:0 10px" src="@/assets/img/homePage/woocommerce.png" alt="">
      </div>
      <div class="img">
        <oss-img :width="160" :height="160" src="https://img.kakaclo.com/web-img/home/empty.png" />
      </div>
      <div style="color: #8B93A3;margin-bottom:26px">{{ $t('Components.SelectStoreToPublish.NOStoreFound') }}</div>
      <el-button type="primary" @click="jump">{{ $t('Components.SelectStoreToPublish.ConnectANewStore') }}</el-button>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      publishVisible: false,
      kkProductId: '',
      platformSelect: [{
        platformCode: `${this.$t('Components.SelectStoreToPublish.SP')}`,
        platformName: `${this.$t('Components.SelectStoreToPublish.Shopify')}`
      }],
      storeSelect: [],
      publishForm: {
        platform: undefined,
        storeId: undefined
      },
      publishRules: {
        platform: [{ required: true, message: `${this.$t('Components.SelectStoreToPublish.Tips3')}`, trigger: 'change' }],
        storeId: [{ required: true, message: `${this.$t('Components.SelectStoreToPublish.Tips4')}`, trigger: 'change' }]
      },
      noShopVisible: false // 没有店铺弹窗
    }
  },
  created() {
    this.$store.state.common.token && this.getUserPlatform()
  },
  methods: {
    show(kkProductId) {
      this.kkProductId = kkProductId
      if (this.platformSelect.length === 0) {
        // this.$message.info(this.$t('promptText.msg5'))
        this.noShopVisible = true
      } else {
        this.publishVisible = true
        if (this.platformSelect.length === 1) {
          this.$set(this.publishForm, 'platform', this.platformSelect[0].platformCode)
          this.platformChange('default_first')
        }
      }
    },
    getUserPlatform() {
      API.getUserPlatform().then(result => {
        this.platformSelect = result.data
      })
    },
    platformChange(isDefault) {
      this.publishForm.storeId = undefined
      this.getStoreSelect(isDefault)
    },
    getStoreSelect(isDefault) {
      API.getStoreSelect({
        platformCode: this.publishForm.platform,
        userId: this.$store.state.common.userId,
        storeStatus: 1,
        authorizeStatus: 1
      }).then(result => {
        this.storeSelect = result.data
        if (this.storeSelect.length === 0) {
          this.$message.info(this.$t('promptText.msg5'))
        }
        if (this.storeSelect.length === 1 && isDefault === 'default_first') {
          this.$set(this.publishForm, 'storeId', this.storeSelect[0].storeId)
        }
      })
    },
    publish() {
      this.$refs.publishForm.validate(async(valid) => {
        if (!valid) return
        if (this.publishForm.platform === 'SP') {
          let res = await API.getPublications({ storeId: this.publishForm.storeId })
          if (res.code === 10000 && res.data) {
            this.publishVisible = false
            this.$emit('storePublications', res.data)
            return
          }
        }

        const store = this.storeSelect.find(item => item.storeId === this.publishForm.storeId)
        const platform = this.platformSelect.find(item => item.platformCode === this.publishForm.platform)
        this.toPublishPage(store.storeId, store.storeName, platform.platformCode, platform.platformName)
      })
    },
    toPublishPage(storeId, storeName, platformCode, platformName) {
      this.$router.push({
        path: '/publish/edit',
        query: {
          kkProductId: this.kkProductId,
          storeId: storeId,
          storeName: storeName,
          platformCode,
          platformName
        }
      })
    },
    jump() {
      this.noShopVisible = false
      window.open('/personal-center/store-manage')
      // this.$router.push('/personal-center/store-manage')
    }
  }
}
</script>

<style lang="scss" scoped>
.publish-dialog /deep/.el-dialog__body{
  padding: 0 20px;
}
.publish-dialog /deep/.el-dialog__footer{
  padding-top: 0;
}
.publish-text{
  line-height: 50px;
}
.no-shop {
  /deep/ .el-dialog__body{
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    button{
      width: 100%;
      // margin: 20px 0 30px 0;
      padding: 15px;
    }
  }
  /deep/ .el-dialog__title {
    font-weight: 600;
  }
  .img {
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
    >img {
      width: 100%;
      height: 100%;
    }
  }
}

/deep/.el-input__inner {
  border-radius: 4px !important;
}
</style>
